// src/components/common/ScrollToTop.js
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;

    window.scrollTo(0, 0);
    document.documentElement.scrollTo(0, 0);
    document.body.scrollTo(0, 0);

    const containers = [
      ".product-detail-page",
      ".App",
      ".main",
      "#root",
    ];
    containers.forEach((sel) => {
      const el = document.querySelector(sel);
      if (el && typeof el.scrollTo === "function") el.scrollTo(0, 0);
      if (el) el.scrollTop = 0;
    });
  }, [pathname, search, hash]);

  return null;
}